import { WINDOW_SIZE_CHANGED_START } from '../actions/windowSize';
import { isMobile } from 'react-device-detect';

const initialState = {
	windowSizeIsTiny: null,
	windowSizeIsSmall: null,
	windowSizeIsMedium: null,
	windowSizeIsLarge: null,
	isMobile: isMobile,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case WINDOW_SIZE_CHANGED_START:
			const dashboard = $('#dashboard').add(document.body);
			if(action.payload.windowSizeIsLarge) {
				dashboard.addClass('dashboard-lg dashboard-md dashboard-sm dashboard-xs');
			}
			else if(action.payload.windowSizeIsMedium) {
				dashboard.addClass('dashboard-md dashboard-sm dashboard-xs');
				dashboard.removeClass('dashboard-lg');
			}
			else if(action.payload.windowSizeIsSmall) {
				dashboard.addClass('dashboard-sm dashboard-xs');
				dashboard.removeClass('dashboard-lg dashboard-md');
			}
			else {
				dashboard.addClass('dashboard-xs');
				dashboard.removeClass('dashboard-lg dashboard-md dashboard-sm');
			}
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
}